import Timeline from "./Timeline";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { signUp } from "aws-amplify/auth"
import { orangeButton, buttonNoPadding, formTextbox, formTextarea, formTextboxContainer, formTextboxLabel } from "../../../Constants/Styles";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../Constants/Toast';
import VendorForm from './VendorForm';
import ProductForm from './ProductForm';
import AccountForm from './AccountForm';
import { createVendor } from '../../API_Handler';

const SignupForm = () => {
    const navigate = useNavigate();
    const [section, setSection] = useState(0);
    const [accountDetails, setAccountDetails] = useState({
        contactName: '',
        title: '',
        email: '',
        phoneNumber: '',
        newPassword: '',
        confirmNewPassword: '',
        interestedInAPI: false,
        agreeToTerms: false,
    });
    const [vendorDetails, setVendorDetails] = useState({
        vendorName: '',
        description: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        website: '',
        yearFounded: '',
        numberOfEmployees: '',
        revenue: '',
        isInnovationChallengeParticipant: false,
    });
    const [productDetails, setProductDetails] = useState({
        serviceSpecialties: '',
        serviceDescription: '',
        servicePlanDescription: '',
    });

    const [loading, setLoading] = useState(false);

    async function createNewUser(e) {
        try {
            setLoading(true);
            const { isSignUpComplete, nextStep } = await signUp({
                username: e.email,
                password: e.newPassword,
                options: {
                    autoSignIn: true
                }
            });

            const payload = {
                "email": e.email,
                "vendorName": vendorDetails.vendorName,
                "vendorDescription": vendorDetails.description.replace(/\n/g, '\\n'),
                "vendorAddress": vendorDetails.address + ", " + vendorDetails.city + ", " + vendorDetails.state + " " + vendorDetails.zipCode,
                "vendorWebsite": vendorDetails.website,
                "vendorYearFounded": vendorDetails.yearFounded,
                "vendorEmployees": vendorDetails.numberOfEmployees,
                "vendorRevenue": vendorDetails.revenue,
                "vendorContact": e.contactName,
                "vendorTitle": e.title,
                "vendorPhone": e.phoneNumber,
                "vendorSpecialties": productDetails.serviceSpecialties,
                "vendorServeDesc": productDetails.serviceDescription,
                "vendorGoals": productDetails.servicePlanDescription.replace(/\n/g, '\\n'),
                "vendorAPI": JSON.stringify(e.interestedInAPI),
                "vendorCHIC": JSON.stringify(vendorDetails.isInnovationChallengeParticipant)
            }

            const response = await createVendor(payload);
            // TODO add logic to handle the response from the API, if it fails, we need to retry it or DELETE THE COGNITO
            navigate('/vendors/validatePage');

        } catch (error) {
            if (error.name === 'UsernameExistsException') {
                alert('Error: There is already a user with this email! Please log in or sign up with a different email');
            }            
            setLoading(false);
        }
    }

    return (
        <div className='w-full h-screen flex flex-col items-center'>
            <div className="w-full flex flex-col z-50">
                <div className="w-full h-[60px] justify-end px-24 flex flex-row gap-2">
                    <div className="flex items-center justify-center">
                        <p className="font-proximanova text-[18px] mb-0">Already a Vendor?</p>
                        <button className="font-proximanova text-[18px] text-charmOrange border-b ml-2 pb-0.5 leading-none" onClick={() => navigate('/vendors/login')}>Sign In Here</button>
                    </div>
                </div>

                <div className="pt-[16px] pb-[8px]   w-full h-fit">
                    <Timeline currentStep={section} />
                </div>
            </div>

            <div className="w-full mt-16 overflow-y-auto">
                {loading ? (
                    <div className="w-full px-16 ">
                        <div className="flex flex-col items-center justify-center h-[40rem] w-full">
                            <div className=" animate-spin rounded-full h-28 w-28 border-t-2 border-b-2"></div>
                            <p className="mt-8 text-lg md:text-xl 2xl:text-2xl">Please wait while we submit your application</p>
                        </div>
                    </div>
                ) : section === 0 ? (
                    <VendorForm
                        setVendorDetailsParent={setVendorDetails}
                        setSection={setSection}
                        formTextboxContainer={formTextboxContainer}
                        formTextboxLabel={formTextboxLabel}
                        formTextbox={formTextbox}
                        formTextarea={formTextarea}
                        orangeButton={orangeButton}
                    />
                ) : section === 1 ? (
                    <ProductForm
                    setProductDetailsParent={setProductDetails}
                    setSection={setSection}
                    formTextboxContainer={formTextboxContainer}
                    formTextboxLabel={formTextboxLabel}
                    formTextbox={formTextbox}
                    formTextarea={formTextarea}
                    orangeButton={orangeButton}
                  />
                ) : (
                    <AccountForm
                    setAccountDetailsParent={setAccountDetails}
                    setSection={setSection}
                    createNewUser={createNewUser}
                    formTextboxContainer={formTextboxContainer}
                    formTextboxLabel={formTextboxLabel}
                    formTextbox={formTextbox}
                    orangeButton={orangeButton}
                  />
                )}
            </div>
        </div>
    );
}

export default SignupForm;